import React, { useEffect, useState } from "react";

import Button from "../../atoms/button/button";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import Loading from "../../atoms/loading/loading";
import { getLikes, addLike } from "../../../services/CMS";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

import "./clubVotes.scss";

interface ClubVotesProps {
  contentful_id: string;
  tipoComponente: string;
  titulo: string;
  tituloBoton: string;
  redireccionBoton: string | null;
  descripcion: { json: any };
  imagenPrincipal: {
    title: string;
    file: {
      url: string;
      fileName: string;
    };
    gatsbyImageData: any;
  };
  tituloGeneral: string;
  autoresArticulo: Array<any>;
  referenciaTabsContenido: Array<{
    autorLibro: string;
    contentful_id: string;
    titulo: string;
    nombreTab: string;
    like: number;
    imagenLibro: {
      title: string;
      file: {
        url: string;
        fileName: string;
      };
      fluid: any;
    };
  }>;
  gtmClass: string;
}

const ClubVotes = (props: ClubVotesProps) => {
  const {
    tituloGeneral,
    descripcion,
    tituloBoton,
    referenciaTabsContenido,
    contentful_id,
  } = props;

  const [bookSelected, setBookSelected] = useState(-1);
  const [votesByBook, setVotesByBook] = useState<any>([]);
  const [votesAvailable, setVotesAvailable] = useState<any>(null);
  const [totalVotes, setTotalVotes] = useState(0);
  const { isBrowser, localStorage } = useBrowserMode();

  useEffect(() => {
    doVote();
  }, []);

  const doVote = async () => {
    const votes: any = [];
    let auxTotalVotes = 0;
    if (
      isBrowser &&
      localStorage.getItem(`comfama:voteBook.${contentful_id}`) === "true"
    ) {
      for (let i = 0; i < referenciaTabsContenido.length; i++) {
        const res = await getLikes(referenciaTabsContenido[i].contentful_id);
        auxTotalVotes += res;
        votes.push(res);
      }
      setTotalVotes(auxTotalVotes);
      setVotesAvailable(false);
      return setVotesByBook(votes);
    }
    setVotesAvailable(true);
  };

  const dateText = descripcion.json.content[1].content[0].content[0].content[0].value.split(
    "\n"
  );

  const makeVote = async () => {
    setVotesAvailable(false);
    const res = await getLikes(
      referenciaTabsContenido[bookSelected].contentful_id
    );
    await addLike(referenciaTabsContenido[bookSelected].contentful_id, res);
    let auxVotes = votesByBook;
    let auxTotalVotes = 0;
    for (let i = 0; i < referenciaTabsContenido.length; i++) {
      const res = await getLikes(referenciaTabsContenido[i].contentful_id);
      auxTotalVotes += res;
      auxVotes.push(res);
    }
    setTotalVotes(auxTotalVotes);
    auxVotes[bookSelected] = res + 1;
    setVotesByBook(auxVotes);

    isBrowser &&
      localStorage.setItem(`comfama:voteBook.${contentful_id}`, "true");
  };

  return (
    <article className="o-club-votes">
      <div className="o-club-votes__texts">
        <h3 className="o-club-votes__texts__title">
          {votesAvailable
            ? tituloGeneral
            : "¡Gracias por votar por tu favorito!"}
        </h3>
        <p className="o-club-votes__texts__desc">
          {votesAvailable
            ? descripcion.json.content[0].content[0].value
            : "Una vez finalizada la votación, podrás conocer el ganador de la semana."}
        </p>
        <p className="o-club-votes__texts__date">
          {dateText.map(
            (text, idx) =>
              text && (
                <React.Fragment key={idx}>
                  {text}
                  <br />
                </React.Fragment>
              )
          )}
        </p>
      </div>
      <div className="o-club-votes__vote-section">
        <div className="o-club-votes__vote-section__books">
          {referenciaTabsContenido?.map((book, index) => (
            <div
              key={index}
              className={`o-club-votes__vote-section__books__book
                ${
                  bookSelected === index
                    ? "o-club-votes__vote-section__books__book--selected"
                    : ""
                }
                ${
                  !votesAvailable
                    ? "o-club-votes__vote-section__books__book--not-vote"
                    : ""
                }`}
              onClick={() => (votesAvailable ? setBookSelected(index) : true)}
            >
              <i className="icon icon-check" />
              <img src={book.imagenLibro.file.url} alt={book.imagenLibro.title}/>
              <div className="o-club-votes__vote-section__books__book__name-author">
                <p className="o-club-votes__vote-section__books__book__name">
                  {book.nombreTab}
                </p>
                <p className="o-club-votes__vote-section__books__book__author">
                  {book.autorLibro}
                </p>
              </div>
              {votesAvailable ? (
                <div className="o-club-votes__vote-section__books__book__radio">
                  <div className="o-club-votes__vote-section__books__book__radio__circle">
                    {bookSelected === index && (
                      <div className="o-club-votes__vote-section__book-selected"></div>
                    )}
                  </div>
                </div>
              ) : (
                votesByBook[index] !== undefined && (
                  <div className="o-club-votes__vote-section__books__book__numbers">
                    <p className="o-club-votes__vote-section__books__book__percentage">
                      {Math.round((100 * votesByBook[index]) / totalVotes)}%
                    </p>
                    <p className="o-club-votes__vote-section__books__book__votes">
                      {votesByBook[index]} votos
                    </p>
                  </div>
                )
              )}
            </div>
          ))}
        </div>
        {!votesAvailable && votesByBook.length === 0 && <Loading dark={true} />}
        {votesAvailable && (
          <div className="o-club-votes__vote-section__button">
            <Button
              type="button"
              classname="secondary"
              text={tituloBoton}
              isDisabled={bookSelected === -1}
              onClickAction={async () => makeVote()}
              gtmMark={`gtm${props.gtmClass}${normalizeTwoWords(
                tituloGeneral
              )}${normalizeTwoWords(tituloBoton)}`}
            />
          </div>
        )}
      </div>
    </article>
  );
};

export default ClubVotes;
